import { atom } from 'recoil';

export const extractionTokenAtom = atom<string | null | undefined>({
  key: 'extraction-token-atom',
  default: undefined,
});
